const reviewParams = (accountId, salesTransactionId) => ({
  accountId,
  salesTransactionId,
});

export const salesReviewReturnQuery = Object.freeze({ return_to: 'review' });
export const salesDeliveryReturnQuery = Object.freeze({
  return_to: 'delivery',
});

export const salesReviewLocation = ({ accountId, salesTransactionId }) => ({
  name: 'operacao_imobiliaria_vendas_revisar',
  params: reviewParams(accountId, salesTransactionId),
});

export const salesReviewPartyLocation = ({
  accountId,
  partyRole,
  salesTransactionId,
}) => ({
  name: 'operacao_imobiliaria_vendas_revisar_partes',
  params: { ...reviewParams(accountId, salesTransactionId), partyRole },
});

export const salesDeliveryLocation = ({ accountId, salesTransactionId }) => ({
  name: 'operacao_imobiliaria_vendas_entregar_avaliando',
  params: reviewParams(accountId, salesTransactionId),
});

export const shouldReturnToSalesReview = route =>
  route.query?.return_to === salesReviewReturnQuery.return_to;

export const shouldReturnToSalesDelivery = route =>
  route.query?.return_to === salesDeliveryReturnQuery.return_to;
